const CurrencyPlugin = {
    install(Vue) {
        Vue.prototype.$formatCurrency = function(amount, currencyCode) {
            const formatter = new Intl.NumberFormat('en-US', { // Adjust locale as needed
                style: 'currency',
                currency: currencyCode,
            });
            return formatter.format(amount);
        };
    }
};

export default CurrencyPlugin;
